import React from 'react';

const FourImageGrid = () => {
  const images = [
    "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=400",
    "https://images.unsplash.com/photo-1535043934128-cf0b28d52f95?w=400",
    "https://images.unsplash.com/photo-1515347619252-60a4bf4fff4f?w=400",
    "https://images.unsplash.com/photo-1523374228107-6e44bd2b524e?w=400"
  ];

  return (
    <section className="four-image-grid">
      <div className="container">
        <div className="grid-four-images">
          {images.map((img, idx) => (
            <div key={idx} className="grid-image-item">
              <img src={img} alt={`Grid ${idx + 1}`} />
            </div>
          ))}
        </div>
        <div className="see-more-wrapper">
          <button className="see-more-btn">SEE MORE</button>
        </div>
      </div>
    </section>
  );
};

export default FourImageGrid;